import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieContext = createContext();

export const CookieProvider = ({ children }) => {
  const [consent, setConsent] = useState(null); // null = not decided yet

  useEffect(() => {
    // Check if user previously decided
    const savedConsent = localStorage.getItem('cookie_consent');
    if (savedConsent) {
      setConsent(savedConsent);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setConsent('accepted');
  };

  const declineCookies = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setConsent('declined');
  };

  const resetCookies = (e) => {
    if(e) e.preventDefault();
    localStorage.removeItem('cookie_consent');
    setConsent(null);
    window.location.reload(); // Reload to ensure all scripts are cleared
  };

  return (
    <CookieContext.Provider value={{ consent, acceptCookies, declineCookies, resetCookies }}>
      {children}
    </CookieContext.Provider>
  );
};

export const useCookie = () => useContext(CookieContext);